import { render, staticRenderFns } from "./HotelReport.vue?vue&type=template&id=74dc8c5b&scoped=true&"
import script from "./HotelReport.vue?vue&type=script&lang=js&"
export * from "./HotelReport.vue?vue&type=script&lang=js&"
import style0 from "./HotelReport.vue?vue&type=style&index=0&id=74dc8c5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc8c5b",
  null
  
)

export default component.exports